import sanitizeContext from './sanitizeContext';
import toError from './toError';

export default class ErrorWithContext extends Error {
  context: Record<string, any>;

  error: Error;

  constructor(err: unknown, context: Record<string, any>) {
    super();
    this.error = toError(err);
    this.context = sanitizeContext(context);

    Object.defineProperty(this, 'message', { get: () => this.error.message });

    Object.defineProperty(this, 'stack', { get: () => this.error.stack });
  }
}
